import { put, takeLatest, takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertTrySelect,
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectLotteryTable: "[selectLotteryTable] Action",
  selectLotteryTableLoad: "[selectLotteryTableLoad] Action",
  selectLotteryTableAsync: "[selectLotteryTableAsync] Action",
};

const initialState = {
  data: [],
  loading: false,
};

export const select_lottery_table_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectLotteryTable:
      return {
        ...state,
        data: payload?.data?.results ? payload?.data?.results : [],
      };

    case actionTypes.selectLotteryTableLoad:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
    yield put({ type: actionTypes.selectLotteryTableLoad, payload: true });
    let config = {
        url: "select_request",
    };
    
    let data = {
        table: "lottery",
        method_type: "select_lottery_registration",
        data: {},
        sort_by: {},
        size: "50",
        from: "0",
    };
    

    try {
    let res = yield AxiosCustom(config, data);


    yield put({
      type: actionTypes.selectLotteryTable,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
    // yield put({ type: actionTypes.creaditSelectLoad, payload: false });
  } finally {
    yield put({ type: actionTypes.selectLotteryTableLoad, payload: false });
  }
}

export function* selectTableLottery() {
  yield takeEvery(actionTypes.selectLotteryTableAsync, handleWorker);
}
